// extracted by mini-css-extract-plugin
var _1 = "DashboardSeverityDot-moduledot__ANNrJ";
var _2 = "DashboardSeverityDot-moduleerror__jyLie";
var _3 = "DashboardSeverityDot-moduleinProgress__SbThC";
var _4 = "DashboardSeverityDot-moduleinfo__uFUXm";
var _5 = "DashboardSeverityDot-modulesuccess__YtCsQ";
var _6 = "DashboardSeverityDot-modulewarning__Owrt0";
export { _1 as "dot", _2 as "error", _3 as "inProgress", _4 as "info", _5 as "success", _6 as "warning" }
